import type { Transaction, TransactionWithRiskAssessment } from 'types/api/transaction';

import useApiQuery from 'lib/api/useApiQuery';

export default function useMergeWithRiskAssessment(items?: Array<Transaction>) {
  const txsAnalysesQuery = useApiQuery('ai:transactions_analyses', {
    queryParams: {
      transactionHashes: items?.map(item => item.hash),
    },
  });

  const queryData = txsAnalysesQuery.data;

  if (!queryData || !items) return items;

  const itemsWithRiskAsssessment = items?.map((item) => {
    const txRiskAssessment = queryData.data?.find(tx => tx.transactionHash === item.hash)?.riskAssessment;
    return { ...item, riskAssessment: txRiskAssessment } as TransactionWithRiskAssessment;
  });

  return itemsWithRiskAsssessment;
}
